export class ProformaTemplate
{
	proformaTemplateId: number;

	// Metadata
	templateName: string;
	templateDescription: string;
	isActive: boolean;

	// Default values
	defaultMgmtFeePCT: number;
	defaultInitialTermMonths: number;
	defaultSubsequentTermMonths: number;
	defaultFreeDepartureCleanNUM: number;
	defaultFreeCarDaysNUM: number;
	defaultSignCreditAMT: number;
	defaultRemodelCreditAMT: number;
	defaultUpgradeCredit: number;
	defaultMgmtFeeCreditAMT: number;
	defaultOtherCreditAMT: number;

	// Slider guardrails
	propertiesMin: number;
	propertiesMax: number;
	propertiesDefault: number;
	termLengthMin: number;
	termLengthMax: number;
	termLengthStep: number;
	termLengthDefault: number;
	ownerDaysMin: number;
	ownerDaysMax: number;
	ownerDaysDefault: number;
	ownerCleaningsMin: number;
	ownerCleaningsMax: number;
	ownerCleaningsDefault: number;
	rentalCarDaysMin: number;
	rentalCarDaysMax: number;
	rentalCarDaysDefault: number;
	unitConditionDefault: number;

	// Fee formula
	baseMgmtFeePCT: number;
	perPropertyDiscountPCT: number;
	perTermMonthDiscountPCT: number;
	mgmtFeeFloorPCT: number;
	mgmtFeeCeilingPCT: number;

	// Default expenses
	proformaTemplateExpenses: ProformaTemplateExpense[];
}

export class ProformaTemplateExpense
{
	proformaTemplateExpenseId: number;
	name: string;
	feeType: string;
	description: string;
	quantity: number;
	expenseAmnt: number;
	expensePct: number;
	expenseFreq: number;
	proformaTemplateId: number;
}
